import { render, staticRenderFns } from "./InventoryFeature.vue?vue&type=template&id=eece3c98&scoped=true&"
import script from "./InventoryFeature.vue?vue&type=script&lang=js&"
export * from "./InventoryFeature.vue?vue&type=script&lang=js&"
import style0 from "./InventoryFeature.vue?vue&type=style&index=0&id=eece3c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eece3c98",
  null
  
)

export default component.exports